
//REMOVE SCROLL FROM PAGE
export const noScroll = () =>{
	
	document.querySelector('html').style.overflow = "hidden";
}

//ADDS SCROLL TO PAGE
export const  addScroll = () => {
	
	document.querySelector('html').style.overflow = "visible";
}

export const bodyHeight = (num) => {

	document.body.style.height = `${num.toString()}.px !important`;
}